import { FC, ReactNode, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@beeline/design-system-react/extracted-styles';

import { DeskAttributes } from 'src/components/DeskAttributes/DeskAttributes';
import { Panel } from 'src/components/Panel/Panel';
import { Section } from 'src/components/Section/Section';
import { getDesksState } from 'src/store/desks/selectors';
import { desksActions } from 'src/store/desks/slice';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const DeskBookingFiltersSidesheetPanel: FC = () => {
  const dispatch = useAppDispatch();
  const { byWindow, withDivider, withMonitor } = useSelector(getDesksState);

  const close = useCallback(() => {
    dispatch(sidesheetActions.close());
  }, [dispatch]);

  const applyFilters = useCallback(() => {
    dispatch(desksActions.applyFilters());
    close();
  }, [close, dispatch]);

  const resetFilters = useCallback(() => {
    dispatch(desksActions.resetFilters());
    close();
  }, [close, dispatch]);

  const setByWindow = useCallback(
    (value: boolean) => {
      dispatch(desksActions.setByWindow(value));
    },
    [dispatch],
  );

  const setWithMonitor = useCallback(
    (value: boolean) => {
      dispatch(desksActions.setWithMonitor(value));
    },
    [dispatch],
  );

  const setWithDivider = useCallback(
    (value: boolean) => {
      dispatch(desksActions.setWithDivider(value));
    },
    [dispatch],
  );

  const actions = useMemo(
    (): ReactNode => (
      <>
        <Button
          variant='outlined'
          onClick={resetFilters}
          data-testid='resetDeskBookingFilters'
        >
          Сбросить
        </Button>
        <Button
          variant='contained'
          onClick={applyFilters}
          data-testid='applyDeskBookingFilters'
        >
          Применить
        </Button>
      </>
    ),
    [applyFilters, resetFilters],
  );

  return (
    <Panel actions={actions}>
      <Section
        title='Что в себя включает место'
        data-testid='bookDeskAttributes'
      >
        <DeskAttributes
          byWindow={byWindow}
          onChangeByWindow={setByWindow}
          withMonitor={withMonitor}
          onChangeWithMonitor={setWithMonitor}
          withDivider={withDivider}
          onChangeWithDivider={setWithDivider}
        />
      </Section>
    </Panel>
  );
};
